"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactIs = _interopRequireDefault(require("react-is"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListEmptyLabel = _interopRequireDefault(require("../ListEmptyLabel"));

var _useIsListItemDivider = _interopRequireDefault(require("../useIsListItemDivider"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

/**
 * Adaptace material-ui List s automatickym zobrazenim empty message a dividermi itemu.
 *
 * @component
 */
var ListPretty = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      listEmptyLabel = _ref.listEmptyLabel,
      ListEmptyLabelProps = _ref.ListEmptyLabelProps,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "listEmptyLabel", "ListEmptyLabelProps"]);
  var isDivider = (0, _useIsListItemDivider.default)();

  var _React$useMemo = _react.default.useMemo(function () {
    var count = _react.default.Children.count(children);

    return [count, _react.default.Children.map(children, function (child, index) {
      return _reactIs.default.isElement(child) ? /*#__PURE__*/_react.default.cloneElement(child, {
        divider: isDivider(count, index)
      }) : child;
    })];
  }, [children, isDivider]),
      _React$useMemo2 = (0, _slicedToArray2.default)(_React$useMemo, 2),
      childrenCount = _React$useMemo2[0],
      items = _React$useMemo2[1];

  return childrenCount > 0 ? /*#__PURE__*/_react.default.createElement(_List.default, (0, _extends2.default)({
    ref: ref
  }, rest), items) : /*#__PURE__*/_react.default.createElement(_ListEmptyLabel.default, ListEmptyLabelProps, listEmptyLabel);
});

process.env.NODE_ENV !== "production" ? ListPretty.propTypes = {
  listEmptyLabel: _propTypes.default.node
} : void 0;
ListPretty.displayName = 'ListPretty';

var _default = (0, _withThemeProps.default)({
  name: 'ListPretty'
})(ListPretty);

exports.default = _default;